export default {
  COMPLIANCEPAGE: 'compliance',
  SURGEONPAGE: 'surgeonpage',
  PATIENTLIST: 'patientlist',
  ADDPATIENT: 'addpatient',
  SELECTCAREPLAN: 'selectcareplan',
  DEVSCHED: 'devschedule',
  ASSIGNREGIMEN: 'assignregimen',
  EXESCHED: 'exeschedule',
  FEEDSCHED: 'feedschedule',
  ADDUSER: 'adduser',
  USERLIST: 'userlist',
  MESSAGES: 'messages',
  REMINDER: 'reminders',
  SUPPORT: 'support',
}
